module.exports = __webpack_public_path__ + "img/pic34.881d9e25.png";